import * as React from 'react';

import {convertToObj} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import {convertToModels} from 'shells/filter-capsule/convert-to-models';
import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

import type {ReportURLParams} from '../../../reports/report-types';

export type StatusFilter = {
    id: string;
    name: string;
};
type Props = {
    dripSequenceId: string;
    filters: FilterObject[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    statusFilters: StatusFilter[];
};

export function DripSequenceRecipientEngagementFilter(props: Props) {
    const {baseFilters, activeRecipientFilters} = getActiveFilters(
        props.filters,
        props.statusFilters
    );

    // The currently active recipient filters in format displayable by FilterCapsule
    const displayableRecipientFilters: any = activeRecipientFilters.length
        ? {
              anyAll: 'any',
              data: activeRecipientFilters.map((filter) => {
                  const [filterId] = Object.getOwnPropertyNames(filter);

                  return {data: filterId};
              }),
          }
        : undefined;

    function handleUpdateActiveFilters(activeFilters: FilterObject[]) {
        props.onParamChange(
            {
                filter: convertToObj(activeFilters),
                list: {
                    ...props.urlParams.list,
                    page: 1,
                },
            },
            false
        );
    }

    return (
        <FilterCapsule
            hasSearch={false}
            filter={displayableRecipientFilters}
            defaultFilter={undefined}
            // @ts-expect-error
            title='Recipient status'
            key='recipientStatus'
            size='big'
            collection={convertToModels(props.statusFilters)}
            filterName='recipientStatus'
            schemaField={{
                type: 'enum',
                cellType: 'description',
                enum: props.statusFilters.map((recipientFilter) => ({
                    id: recipientFilter.id,
                    name: recipientFilter.name,
                    type: 'enum',
                })),
                title: 'Recipient status',
                description: 'Status of the drip sequence recipient',
                isFilterable: true,
                isDisplayable: true,
                isSortable: true,
                isAndable: false,
                size: 'sm',
                name: 'recipientStatus',
            }}
            onSubmit={(filterObj) => {
                handleUpdateActiveFilters(
                    getUpdatedActiveFilters(filterObj, baseFilters, props.dripSequenceId)
                );
            }}
            onRemove={() => handleUpdateActiveFilters(baseFilters)}
        />
    );
}

/* Returns lists of current baseFilters and activeRecipientFilters */
function getActiveFilters(filters: FilterObject[], statusFilters: StatusFilter[]) {
    const recipientFilterNames = statusFilters.map((recipientFilter) => recipientFilter.id);

    // @ts-expect-error
    const baseFilters = [];
    // @ts-expect-error
    const activeRecipientFilters = [];

    filters.forEach((filter) => {
        const [filterName] = Object.getOwnPropertyNames(filter);

        // @ts-expect-error
        if (recipientFilterNames.includes(filterName)) {
            activeRecipientFilters.push(filter);
        } else {
            baseFilters.push(filter);
        }
    });

    // @ts-expect-error
    return {baseFilters, activeRecipientFilters};
}

/* Returns updated list of all active filters after applying currently selected filters from recipientStatus filter. */
function getUpdatedActiveFilters(
    recipientStatusFilterObj: FilterObject,
    baseFilters: FilterObject[],
    dripSequenceId: string
) {
    const {recipientStatus} = recipientStatusFilterObj;
    const selectedFilters = recipientStatus.data;

    const activeFilters = [...baseFilters];

    // @ts-expect-error
    selectedFilters.forEach((filter) => {
        activeFilters.push({
            [filter.data]: dripSequenceId,
        });
    });

    return activeFilters;
}
